<template>
  <div class="row centered-form">
    <v-title>Order Attachments</v-title>
    <v-card>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex sm12 md12 lg12>
              <FileUploader :is-on-upload-page="true">
                Order Attachments
              </FileUploader>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import FileUploader from './FileUploader';

export default {
  name: 'OrderAttachments',
  components: { FileUploader: FileUploader },
};
</script>
